import { Testimonial } from "@entities/testimonials";
import { RatingDots } from "@shared/ui/rating";
import { RichText } from "@shared/ui/rich-text";

export type CardProps = {
  testimonial: Testimonial;
  backgroundMode?: "light" | "dark";
  showRating?: boolean;
  className?: string;
};

export function Card({
  testimonial,
  backgroundMode,
  showRating,
  className,
}: CardProps) {
  return (
    <div
      className={[
        `group flex flex-col items-center gap-4 bg-transparent border border-antique-brass-500 rounded-md text-center transition-all transform-gpu duration-300 ${backgroundMode === "dark" ? "text-gray-200" : "text-black-pearl-950"} `,
        className,
      ].join(" ")}
    >
      <div className="flex-1 grid place-items-center mx-1 mt-4 overflow-y-auto scrollbar-light">
        <RichText
          className={"max-h-48 mx-4 text-lg"}
          message={testimonial.answer}
        />
      </div>

      <div
        className={
          "flex flex-col w-full gap-2 border-t border-antique-brass-500 border-opacity-40 py-6 lg:py-10"
        }
      >
        <RichText className={"text-xl"} message={testimonial.client_name} />

        <small
          className={`${backgroundMode === "dark" ? "text-gray-200" : "text-gray-700"} text-sm`}
        >
          {testimonial.service} | {testimonial.answered_at.date}
        </small>

        {showRating && (
          <RatingDots rating={testimonial.highest_rating / 5} dots={5} />
        )}
      </div>
    </div>
  );
}
